import firebase from "firebase/compat/app";
import "firebase/compat/functions";

export async function fetchUsageReport(startDate, endDate, organizationId) {
  const fn = firebase.functions().httpsCallable("getUsageReport");

  const result = await fn({
    startDate: startDate,
    endDate: endDate,
    organizationId: organizationId || null,
  });

  return result.data;
}
